import { ModelBase } from 'store/model-base';

export class CmsAddonDetails extends ModelBase {
    public static storeName: string = 'cmsAddonDetails';

    public details: CmsAddonDetail[];
}
